import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Language } from './language.interface';
import languageService from './language.service';

export interface LanguageState {
   languages?: Array<Language>;
}

const LanguageStore: Module<LanguageState, StoreState> = {
   namespaced: true,
   state: {
      languages: [],
   },

   getters: {},

   mutations: {
      setLanguages(state, languages) {
         state.languages = languages;
      },
   },

   actions: {
      async get({ commit, state }) {
         if (state.languages?.length !== 0) return;
         const LANGUAGES = await languageService.get().then((response) => response?.data);
         commit('setLanguages', LANGUAGES);
      },
   },
};

export default LanguageStore;
